<template>
  <div class="hidden gap-4 xl:grid">
    <div
      v-for="(row, index) in data"
      :key="index"
      class="divide-y overflow-hidden rounded-xl border"
      :class="[
        mode === 'dark'
          ? 'divide-dark-border border-dark-border bg-dark-sidebar'
          : 'divide-border-10 border-border-10 bg-white-100',
      ]"
    >
      <div
        v-for="(label, fieldKey) in fields"
        :key="fieldKey"
        class="flex justify-between divide-x"
        :class="[
          mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
          fieldsWithAlignTop.includes(label) ? 'items-start' : 'items-center',
        ]"
      >
        <div class="w-[150px]">
          <div
            class="p-3 text-[13px] font-semibold uppercase tracking-wider"
            :class="[
              mode === 'dark'
                ? 'text-white-100 text-opacity-80'
                : 'text-black-80',
            ]"
          >
            {{ label }}
          </div>
        </div>
        <div class="flex-1">
          <div
            class="p-3 text-[14px] font-medium"
            :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
          >
            <slot :row="row" :field-key="fieldKey">
              {{ row[fieldKey] }}
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileTable",
  props: {
    mode: String,
    data: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fieldsWithAlignTop: ["Details", "Respondent", "Complainant"],
    };
  },
};
</script>
